import { useAction, useData, useList } from "@inmagik/react-crud"
import { SearchCounts } from "../types"
import { API_URL } from "../constants"
import { Fondo, Documento, Supporto } from "../types"
import { Field } from "react-querybuilder"


export function useSearchFields() {
  return  useData<Field[]>(`${API_URL}/advanced-search-fields`)
}

export function useSearchCounts(query: Record<string, string>) {
  return  useData< SearchCounts>(`${API_URL}/advanced-search-counts`, {query})
}

export function useFondiSearchList(params: Record<string, string | number | string[] | number[]> = {}, enabled = true) {
  return useList<Fondo>(`${API_URL}/advanced-search/fondo`, {
    query: params,
    reactQuery: {
      queryKey: ["fondiSearchList", params],
      enabled,
    }
  })
}

export function useDocumentiSearchList(params: Record<string, string | number | string[] | number[]> = {}, enabled = true) {
  return useList<Documento>(`${API_URL}/advanced-search/documento`, {
    query: params,
    reactQuery: {
      queryKey: ["documentiSearchList", params],
      enabled,
    }
  })
}

export function useSupportiSearchList(params: Record<string, string | number | string[] | number[]> = {}, enabled = true) {
  return useList<Supporto>(`${API_URL}/advanced-search/supporto`, {
    query: params,
    reactQuery: {
      queryKey: ["supportiSearchList", params],
      enabled,
    }
  })
}

export function useDownloadFondiRicerca(params: Record<string, string | number | string[] | number[]> = {}) {
  return useAction<Blob, void>(`${API_URL}/advanced-search-excel/fondo`, { 
    method: "GET",
    query: params,
    responseType: "blob",
  })
}

export function useDownloadDocumentiRicerca(params: Record<string, string | number | string[] | number[]> = {}) {
  return useAction<Blob, void>(`${API_URL}/advanced-search-excel/documento`, {
    method: "GET",
    query: params,
    responseType: "blob",
  })
}

export function useDownloadSupportiRicerca(params: Record<string, string | number | string[] | number[]> = {}) {
  return useAction<Blob, void>(`${API_URL}/advanced-search-excel/supporto`, {
    method: "GET",
    query: params,
    responseType: "blob",
  })
}

